export const GEO_CONFIRM_CROSS = 'geo_confirm_cross';
export const GEO_CONFIRM_YES = 'geo_confirm_yes';
export const GEO_CONFIRM_NO = 'geo_confirm_no';
export const GEO_CONFIRM_FOOTER = 'geo_confirm_footer';
export const GEO_CONFIRM_HEADER = 'geo_confirm_header';
export const GEO_CONFIRM_CHANGE = 'geo_confirm_change';
